import speakers from "$lib/speakers.json";

export function load() {
  return {
    speakers,
  };
}
